import { css } from 'styled-components';

const Paginator = {
  Page: css`

`,
};

export default Paginator;
